// extracted by css-extract-rspack-plugin
export default {"sortableField":"dVjWt","content":"l5O3l","draggable":"YjmPF","grabber":"job_A","label":"AsZzG"};